import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../../global/globals';

@Injectable({ providedIn: 'root' })
export class FirmwareService {
  private baseUrl: string;

  // delay similar to FileService's pageMinDelay
  pageMinDelay = 300;

  constructor(private http: HttpClient, private globals: Globals) {
    this.baseUrl = this.globals.backendUri + '/firmware';
  }

  getAll(filter: {
    page: number,
    size: number,
    softwareType?: string,
    moduleTypeCode?: string,
    chipTypeCode?: string,
    displayTypeCode?: string,
    version?: number,
    isInitializer?: boolean,
    sortList?: {name: string, ascending: boolean}[]
  }): Observable<any> {
    const params: string[] = [];
    if (filter.softwareType) params.push('softwareType=' + encodeURIComponent(filter.softwareType));
    if (filter.moduleTypeCode) params.push('moduleTypeCode=' + encodeURIComponent(filter.moduleTypeCode));
    if (filter.chipTypeCode) params.push('chipTypeCode=' + encodeURIComponent(filter.chipTypeCode));
    if (filter.displayTypeCode) params.push('displayTypeCode=' + encodeURIComponent(filter.displayTypeCode));
    if (filter.version) params.push('version=' + encodeURIComponent(filter.version));
    if (filter.isInitializer !== undefined) params.push('isInitializer=' + filter.isInitializer);
    if (typeof filter.page === 'number') params.push('page=' + filter.page);
    if (typeof filter.size === 'number') params.push('size=' + filter.size);
    // sortList currently unused on backend. Kept for consistency.
    const url = this.baseUrl + (params.length ? ('?' + params.join('&')) : '');
    return this.http.get<any>(url);
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}`);
  }

  upload(file: File, softwareType: string, moduleTypeCode: string, chipTypeCode: string, displayTypeCode: string, isInitializer: boolean): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);
    let url = `${this.baseUrl}?softwareType=${encodeURIComponent(softwareType)}&moduleTypeCode=${encodeURIComponent(moduleTypeCode)}&chipTypeCode=${encodeURIComponent(chipTypeCode)}&displayTypeCode=${encodeURIComponent(displayTypeCode)}&isInitializer=${isInitializer}`;
    return this.http.post(url, formData, {
      observe: 'events',
      reportProgress: true
    });
  }

  update(id: number, softwareType: string, moduleTypeCode: string, chipTypeCode: string, displayTypeCode: string, isInitializer: boolean, file?: File): Observable<any> {
    const formData = new FormData();
    formData.append('id', String(id));
    formData.append('softwareType', softwareType);
    formData.append('moduleTypeCode', moduleTypeCode);
    formData.append('chipTypeCode', chipTypeCode);
    formData.append('displayTypeCode', displayTypeCode);
    formData.append('isInitializer', String(isInitializer));
    if (file) {
      formData.append('file', file);
    }
    return this.http.put(`${this.baseUrl}`, formData);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
